<template>
  <div>
    <!-- init step -->
    <v-card-actions class="justify-space-between">
      <v-spacer></v-spacer>
      <v-item-group v-model="onboarding" class="text-xs-center" mandatory>
        <v-item v-for="n in passos" :key="`btn-${n}`">
          <v-btn
            class="step-analise-credito"
            slot-scope="{ active, toggle }"
            :input-value="active"
            icon
            @click="toggle"
          >
            <i class="material-icons">{{
              active ? "brightness_1" : "panorama_fish_eye"
            }}</i>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- end step -->

    <v-card>
      <!-- init passo 1 -->
      <v-card-text v-if="onboarding == 0">
        <v-container grid-list-xl class="form-analise-credito">
          <v-form ref="formTomador" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <p class="titulo">Dados do Tomador</p>
              </v-flex>

              <v-flex md3 sm12>
                <v-text-field
                  :value="maskCnpj(item.documento)"
                  class="jns-input"
                  label="CNPJ"
                  disabled
                  v-mask="['XX.XXX.XXX/XXXX-XX']"
                  placeholder=" "
                ></v-text-field>
              </v-flex>

              <v-flex md9 sm12>
                <v-text-field
                  v-model="item.razao_social"
                  class="jns-input"
                  label="Razão Social"
                  disabled
                  placeholder=" "
                ></v-text-field>
              </v-flex>

              <v-flex md6 sm12>
                <v-text-field
                  v-model="item.nome_fantasia"
                  class="jns-input"
                  label="Nome Fantasia"
                  placeholder=" "
                  autofocus
                  :rules="[rules.obrigatorio]"
                ></v-text-field>
              </v-flex>

              <v-flex md3 sm12>
                <v-menu
                  lazy
                  v-model="dataFundacaoMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    class="jns-input jns-datepicker"
                    label="Data da Fundação"
                    v-model="dataFundacaoFormatter"
                    append-icon="event"
                    placeholder=" "
                    readonly
                    @click="dataFundacaoMenu = true"
                    @keypress="dataFundacaoMenu = true"
                    :rules="[rules.obrigatorio]"
                  ></v-text-field>
                  <v-date-picker
                    v-model="item.fundacao"
                    @change="dataFundacaoMenu = false"
                    @input="setDataFormat()"
                    no-title
                    scrollable
                    locale="pt-BR"
                    actions
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md3 sm12>
                <v-text-field
                  v-model="item.telefone"
                  class="jns-input"
                  label="Telefone"
                  placeholder=" "
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :rules="[rules.obrigatorio, rules.telefone]"
                ></v-text-field>
              </v-flex>

              <v-flex md6 sm12>
                <v-text-field
                  v-model="item.email"
                  class="jns-input"
                  label="E-mail"
                  placeholder=" "
                  :rules="[rules.obrigatorio, rules.email]"
                ></v-text-field>
              </v-flex>

              <v-flex md6 sm12>
                <v-text-field
                  v-model="item.website"
                  class="jns-input"
                  label="Site"
                  placeholder=" "
                  :rules="[rules.obrigatorio]"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-flex xs12 pl-0>
              <p class="titulo">Endereço</p>
            </v-flex>

            <endereco-component
              :endereco="item.endereco"
              class="mt-3"
              ref="formEnderecoComponent"
            ></endereco-component>

            <v-flex xs12 mb-2 pl-0>
              <p class="titulo">Dados Financeiros</p>
            </v-flex>

            <dados-financeiros-component
              class="mt-3"
              ref="formDadosBancariosComponent"
              :bancos="bancos"
              :item="item"
              :disabledValidation="true"
            ></dados-financeiros-component>
          </v-form>
        </v-container>
      </v-card-text>
      <!-- init passo 1 -->

      <!-- init passo 2 -->
      <v-card-text v-if="onboarding == 1">
        <v-container grid-list-xl class="form-analise-credito">
          <v-form ref="formGrupoEconomico" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 class="container-inline">
                <p class="pt-3 pr-4 titulo">Possui grupo econômico?</p>
                <v-switch
                  v-model="temGrupoEconomico"
                  class="float-right"
                  @change="
                    $forceUpdate();
                    setDocumentos();
                  "
                ></v-switch>
              </v-flex>

              <v-flex xs12>
                <p class="titulo">
                  {{
                    temGrupoEconomico
                      ? "Grupo Econômico"
                      : "Dados do Sócio Majoritário"
                  }}
                </p>
              </v-flex>

              <v-flex md3 sm12>
                <v-text-field
                  v-model="item.grupo_economico.documento"
                  class="jns-input"
                  :label="!temGrupoEconomico ? 'CPF' : 'CNPJ'"
                  :mask="grupoEconomicoMask"
                  placeholder=" "
                  :rules="
                    !temGrupoEconomico
                      ? [rules.obrigatorio, rules.cpfInvalido]
                      : [rules.obrigatorio, rules.cnpjInvalido]
                  "
                  autofocus
                ></v-text-field>
              </v-flex>

              <v-flex md9 sm12>
                <v-text-field
                  v-model="item.grupo_economico.nome"
                  class="jns-input"
                  :label="!temGrupoEconomico ? 'Nome' : 'Razão Social'"
                  placeholder=" "
                  :rules="[rules.obrigatorio]"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <p class="titulo">Interveniente Coobrigado</p>
              </v-flex>

              <v-flex xs12 class="container-inline">
                <p class="pt-3 pr-4 titulo">
                  {{
                    slug != "TRADICIONAL"
                      ? "Tipo de avalista"
                      : "Possui avalista?"
                  }}
                </p>
                <v-switch
                  v-if="slug == 'TRADICIONAL'"
                  v-model="temAvalista"
                  class="float-right"
                  @change="
                    $forceUpdate();
                    setDocumentos();
                  "
                ></v-switch>

                <v-radio-group
                  row
                  class="mb-0 pb-0"
                  v-if="temAvalista"
                  v-model="item.interveniente_coobrigado"
                  @change="setDocumentos()"
                  :rules="[rules.obrigatorio]"
                >
                  <v-radio
                    label="Avalista Pessoa Física"
                    value="AVALISTA_PF"
                  ></v-radio>
                  <v-radio
                    label="Avalista Pessoa Jurídica"
                    value="AVALISTA_PJ"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-form>

          <v-flex xs12>
            <p class="titulo">
              Representantes Legais
              <span class="text-muted ml-2">(conforme contrato social)</span>
            </p>
          </v-flex>

          <pessoa-politicamente-exposta-component
            ref="formRepresentanteComponent"
            :representantesLegais="item.representantes_legais"
            :categoriasPeps="categoriasPeps"
            :ativaEmail="true"
            @validaCategoriaPep="validaCategoriaPep"
          ></pessoa-politicamente-exposta-component>
        </v-container>
      </v-card-text>
      <!-- end passo 2 -->

      <!-- init passo 3 -->
      <v-card-text v-if="onboarding == 2">
        <v-container grid-list-xl class="form-analise-credito">
          <v-flex xs12>
            <p class="titulo">Upload de Documentos</p>
          </v-flex>
          <anexo-list-component
            :documentosSolicitados.sync="pendenciasCopia"
            :classColuna="'lg4 md6 sm12'"
            :mostraDescricao="true"
            :mostraTitulo="true"
            @send="setUpdateDocumentos"
            @setDocumentosModel="this.solicitarAnalise"
          ></anexo-list-component>
        </v-container>
      </v-card-text>
      <!-- end passo 3 -->
    </v-card>

    <v-layout row wrap pt-4>
      <v-flex text-xs-left>
        <v-btn
          class="button jns-button blue-button flex"
          v-show="onboarding > 0 || route != 'POST_REVISAO_CREDITO'"
          @click="prev()"
          >{{ onboarding > 0 ? "Voltar" : "Fechar" }}</v-btn
        >
      </v-flex>
      <v-flex text-xs-right>
        <v-btn
          class="button jns-button yellow-button no-margin-top"
          @click="avancar()"
          >{{
            passos > onboarding + 1 ? "Próximo Passo" : "Solicitar Análise"
          }}</v-btn
        >
      </v-flex>
    </v-layout>

    <v-dialog v-model="documentosSucessoModal" :max-width="'640'">
      <base-modal>
        <h3>Formulário enviado para análise com sucesso!</h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8 pb-0>
            <v-btn
              class="button jns-button yellow-button mt-4"
              @click="fecharModalSucesso()"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
import { eventBus } from "../main";
import { formatDate, maskCnpj, isValidCpf, isValidCnpj } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "ProcessoAnaliseCredito",
  mixins: [ViewMixin],
  data() {
    return {
      maskCnpj,
      grupoEconomicoMask: "XX.XXX.XXX/XXXX-XX",
      pendenciasCopia: [],
      bancos: [],
      categoriasPeps: [],
      passos: 3,
      onboarding: 0,
      dataFundacaoFormatter: null,
      documentosSucessoModal: false,
      dataFundacaoMenu: false,
      temGrupoEconomico: false,
      temAvalista: false,
      rules: {
        obrigatorio: (v) => !!v || "Campo obrigatório",
        cepIvalido: (v) =>
          new RegExp("\\d{5}[-]\\d{3}").test(v) || "Cep inválido",
        cpfInvalido: (v) =>
          (!!v && isValidCpf(v)) || "Documento inválido",
        cnpjInvalido: (v) =>
          (!!v && isValidCnpj(v)) || "Documento inválido",
        documentoInvalido: (v) =>
          (!!v &&
            (v.length > 14
              ? isValidCnpj(v)
              : isValidCpf(v))) ||
          "Documento inválido",
        email: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido",
        telefone: (v) =>
          /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/.test(v) ||
          "Telefone inválido",
      },
    };
  },
  props: {
    item: Object,
    pendencias: Array,
    route: { type: String, default: "POST_REVISAO_CREDITO" },
    slug: String,
  },
  methods: {
    async getCategoriasPep() {
      var data = [];
      try {
        data = await this.$store.dispatch("GET_CATEGORIAS_PEP");
      } catch (e) {
        this.setErrorModal(e.response.data);
        return;
      }

      if (data)
        for (var i = 0; i < data.length; i++)
          this.categoriasPeps.push({
            id: data[i].id,
            descricao: data[i].descricao,
            enumerador: i + 1,
            tooltipShow: false,
          });
    },

    async getBankList() {
      try {
        this.bancos = await this.$store.dispatch("GET_BANK");
      } catch (e) {
        this.setErrorModal(e.response.data);
      }
    },

    async solicitarAnalise(modelDocumentos) {
      var model = {
        documento: this.item.documento,
        razao_social: this.item.razao_social,
        nome_fantasia: this.item.nome_fantasia,
        telefone: this.item.telefone.replace(/[^\d]+/g, ""),
        email: this.item.email,
        website: this.item.website,
        interveniente_coobrigado: this.temAvalista
          ? this.item.interveniente_coobrigado
          : null,
        dados_bancarios: this.item.dados_bancarios,
        endereco: {
          logradouro: this.item.endereco.logradouro,
          bairro: this.item.endereco.bairro,
          cidade: this.item.endereco.cidade,
          uf: this.item.endereco.uf,
          cep: this.item.endereco.cep.replace(/[^\d]+/g, ""),
        },
        grupo_economico: {
          nome: this.item.grupo_economico.nome,
          documento: this.item.grupo_economico.documento.replace(/[^\d]+/g, ""),
          socio_majoritario: this.item.grupo_economico.socio_majoritario,
        },
        fundacao: this.item.fundacao,
        representantes_legais: [],
        documentos: modelDocumentos,
      };

      this.item.representantes_legais.forEach((element) => {
        var item = {
          nome: element.nome,
          documento: element.documento.replace(/[^\d]+/g, ""),
          cargo: element.cargo,
          email: element.email,
          pep: element.pep,
          categorias_pep: [],
        };

        element.categorias_pep.forEach((elementCat) => {
          item.categorias_pep.push({ id: elementCat.id });
        });

        model.representantes_legais.push(item);
      });

      try {
        this.showLoadingIndicator();
        let payload = {};
        if (this.route == "POST_REVISAO_CREDITO")
          payload = {
            propostaId: this.$route.params.propostaId,
            produtoId: this.$route.params.produtoId,
            model: model,
          };
        else
          payload = {
            model: model,
          };

        await this.$store.dispatch(this.route, payload);

        this.documentosSucessoModal = true;
      } catch (e) {
        this.setErrorModal(e.response.data);
        return;
      } finally {
        this.hideLoadingIndicator();
      }
    },

    avancar() {
      var isValid = true;

      switch (this.onboarding) {
        case 0:
          var formEnderecoComponent = this.$refs.formEnderecoComponent;

          if (!this.$refs.formTomador.validate()) isValid = false;
          if (!formEnderecoComponent.$refs.formEndereco.validate())
            isValid = false;

          if (isValid) this.next();
          this.$forceUpdate();

          break;
        case 1:
          var isValid = true;

          if (!this.$refs.formGrupoEconomico.validate()) isValid = false;

          var representanteForm = this.$refs.formRepresentanteComponent;
          for (
            var i = 0;
            i < representanteForm.$refs.formRepresentante.length;
            i++
          ) {
            if (!representanteForm.$refs.formRepresentante[i].validate())
              isValid = false;

            var categoriaIsValid = this.validaCategoriaPep(i);

            if (!categoriaIsValid && isValid) isValid = false;
          }

          if (isValid)
            if (this.pendenciasCopia && this.pendenciasCopia.length) {
              this.next();
            } else this.solicitarAnalise([]);

          this.$forceUpdate();

          break;
        case 2:
          if (this.validaAnexos()) eventBus.$emit("setModelAnexos");
          else this.$forceUpdate();
          break;
      }
    },

    fecharModalSucesso() {
      if (this.route == "POST_REVISAO_CREDITO") this.$router.go();
      else {
        this.documentosSucessoModal = false;
        this.$forceUpdate();

        this.$emit("solicitarLimites", this.item);
      }
    },

    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    prev() {
      if (this.onboarding == 0)
        this.$emit("fecharAnaliseCreditoModal", this.item);
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    setDataFormat() {
      this.dataFundacaoFormatter = formatDate(this.item.fundacao);
      this.$forceUpdate();
    },

    setDocumentos() {
      let removeList = [];
      let pendenciaArquivos = JSON.parse(JSON.stringify(this.pendenciasCopia));
      this.pendenciasCopia = JSON.parse(JSON.stringify(this.pendencias));

      this.pendenciasCopia.forEach((item) => {
        if (
          (!this.temGrupoEconomico && item.categoria == "GRUPO ECONÔMICO") ||
          (!this.temAvalista &&
            (item.categoria == "Avalista PF" ||
              item.categoria == "Avalista PJ")) ||
          (this.temAvalista &&
            ((this.item.interveniente_coobrigado == "AVALISTA_PJ" &&
              item.categoria == "Avalista PF") ||
              (this.item.interveniente_coobrigado == "AVALISTA_PF" &&
                item.categoria == "Avalista PJ")))
        )
          removeList.push(item);
      });

      removeList.forEach((item) => {
        let index = this.pendenciasCopia.indexOf(item);
        this.pendenciasCopia.splice(index, 1);
      });

      /*Caso haja algum arquivo já carregado no objeto antigo e presente no novo 
        a lista de arquivos é atualizada com a lista de arquivos antiga*/
      pendenciaArquivos.forEach((documento) => {
        this.pendenciasCopia.forEach((documentoCopia) => {
          if (documento.categoria == documentoCopia.categoria)
            documento.listagem.forEach((documentoListagem) => {
              if (
                documentoListagem.arquivos &&
                documentoListagem.arquivos.length
              )
                documentoCopia.listagem.forEach((documentoListagemCopia) => {
                  if (documentoListagem.id == documentoListagemCopia.id)
                    documentoListagemCopia.arquivos = JSON.parse(
                      JSON.stringify(documentoListagem.arquivos)
                    );
                });
            });
        });
      });

      if (
        this.slug == "FINANPRIVADO" &&
        this.item.interveniente_coobrigado == "AVALISTA_PF"
      )
        this.pendenciasCopia.forEach((documento) => {
          if (documento.categoria == "Avalista PF")
            documento.listagem.forEach((documentoListagem) => {
              if (documentoListagem.id == 615)
                documentoListagem.obrigatorio = true;
            });
        });

      this.$forceUpdate();
    },

    setUpdateDocumentos(data) {
      this.pendenciasCopia = data;
      this.$forceUpdate();
    },

    validaCategoriaPep(i) {
      var isValid = true;

      if (this.item.representantes_legais[i].pep)
        if (
          !this.item.representantes_legais[i].categorias_pep_selected ||
          this.item.representantes_legais[i].categorias_pep_selected.length == 0
        ) {
          this.item.representantes_legais[i].hasError = true;
          isValid = false;
        } else this.item.representantes_legais[i].hasError = false;

      return isValid;
    },

    validaAnexos() {
      var isValid = true;

      this.pendenciasCopia.forEach((categoria) => {
        if (categoria.listagem && categoria.listagem.length) {
          for (var i = 0; i < categoria.listagem.length; i++) {
            if (
              (!categoria.listagem[i].arquivos ||
                !categoria.listagem[i].arquivos.length) &&
              categoria.listagem[i].obrigatorio
            )
              isValid = false;
          }
        }
      });
      if (!isValid) eventBus.$emit("validaAnexos");

      return isValid;
    },
  },
  created() {
    if (this.item.cnpj_cpf) {
      this.item.documento = this.item.cnpj_cpf;
      this.item.razao_social = this.item.nome;
    }
    if (!this.item.dados_bancarios) this.item.dados_bancarios = {};
    this.getCategoriasPep();
    this.getBankList();
  },
  mounted() {
    if (this.item.fundacao)
      this.dataFundacaoFormatter = formatDate(this.item.fundacao);
    if (!this.item.grupo_economico)
      this.item.grupo_economico = { socio_majoritario: false };
    this.temGrupoEconomico = !this.item.grupo_economico.socio_majoritario;
    if (this.temGrupoEconomico) this.grupoEconomicoMask = "XX.XXX.XXX/XXXX-XX";
    else this.grupoEconomicoMask = "###.###.###-##";
    this.temAvalista =
      !!this.item.interveniente_coobrigado || this.slug != "TRADICIONAL";

    if (this.pendencias && this.pendencias.length) {
      this.setDocumentos();
      if (!this.pendenciasCopia || !this.pendenciasCopia.length) this.passos--;
    } else this.passos--;

    if (!this.item.representantes_legais) this.item.representantes_legais = [];
  },
  watch: {
    temGrupoEconomico: function (value) {
      this.item.grupo_economico.socio_majoritario = !value;

      if (value) this.grupoEconomicoMask = "XX.XXX.XXX/XXXX-XX";
      else this.grupoEconomicoMask = "###.###.###-##";
    },
    temAvalista: function (value) {
      if (!value) this.item.interveniente_coobrigado = null;
    },
    onboarding: function (value) {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 959px) {
  .container {
    padding: 0.5vh 1vh !important;
  }
}

@media only screen and (min-width: 960px) {
  .container {
    max-width: 100% !important;
  }
}

.v-card__title {
  padding: 7vh 0 2vh 0;
  justify-content: center;

  .headline {
    font-weight: 900;
    font-size: 3vh !important;
    color: #061d45;
  }
}

.v-card__actions {
  .v-btn--active:before {
    background-color: transparent;
  }

  i {
    font-size: 1.5vh;
    color: #282498;
  }
}

.v-card__text {
  overflow: auto;
}

.blue-button {
  margin: 6px 8px !important;
}

.v-btn {
  text-transform: none;
}

.button {
  max-width: 25vh;
}

.container,
.v-card__actions {
  padding: 1vh 5vh;
}

.container {
  padding: 0.5vh 5vh !important;
}

.step-analise-credito {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessoAnaliseCredito.vue